import React, { useState } from 'react';

function HomepageVisualCards() {
  // Interactive toggle states for the Security & Compliance Architecture card
  const [toggles, setToggles] = useState({
    auditability: true,
    consent: true,
    residency: true,
    regulatory: true
  });

  const toggleHandler = (key) => {
    setToggles(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="homepage_visual_cards_wrapper py-4">
      <div className="text-center mb-5">
        <span className="badge-lime px-3 py-2 text-uppercase mb-2 font-weight-bold" style={{ letterSpacing: '1px' }}>
          <i className="fa-solid fa-shield-cat me-2"></i>FINTECH RISK &amp; SECURITY ARCHITECTURE
        </span>
        <h2 className="heading_text text-white font-weight-bold display-6">
          Enterprise Security &amp; Compliance Framework
        </h2>
        <p className="mx-auto text-white-50" style={{ maxWidth: '750px', fontSize: '1rem', lineHeight: '1.7' }}>
          Next-generation fraud prevention, automated liveness detection, and Verify compliance architecture powering millions of transactions across India.
        </p>
      </div>

      <div className="row g-4 justify-content-center">
        
        {/* LEFT CARD: Fraud Prevention Card (Styled in Mokshiq Dark Emerald & Lime Green Theme) */}
        <div className="col-lg-6 col-xl-5">
          <div className="card h-100 border-0 rounded-4 shadow-lg overflow-hidden position-relative p-4 p-md-5" style={{ backgroundColor: '#ecfdf5', border: '2px solid #10b981' }}>
            
            {/* Soft decorative emerald background brush shape */}
            <div className="position-absolute rounded-circle" style={{ width: '280px', height: '280px', background: 'radial-gradient(circle, rgba(16,185,129,0.25) 0%, rgba(236,253,245,0) 70%)', top: '-40px', right: '-40px', pointerEvents: 'none' }}></div>
            <div className="position-absolute" style={{ width: '220px', height: '140px', background: 'linear-gradient(135deg, rgba(16,185,129,0.3) 0%, rgba(4,56,54,0.15) 100%)', bottom: '40px', right: '20px', borderRadius: '50px', transform: 'rotate(-12deg)', filter: 'blur(20px)', pointerEvents: 'none' }}></div>

            {/* Top Floating Badge: Risk */}
            <div className="d-flex justify-content-end mb-3">
              <div className="bg-dark-emerald text-white px-3 py-2 rounded-3 shadow-sm d-inline-flex align-items-center gap-2 border" style={{ borderColor: '#ccff00', backgroundColor: '#012b2a' }}>
                <div className="rounded-2 p-1 d-inline-flex align-items-center justify-content-center" style={{ backgroundColor: '#ccff00', color: '#012b2a', width: '26px', height: '26px' }}>
                  <i className="fa-solid fa-chart-simple" style={{ fontSize: '12px' }}></i>
                </div>
                <span className="font-weight-bold small text-lime" style={{ letterSpacing: '0.5px' }}>Risk</span>
              </div>
            </div>

            {/* Main Elevated White Fraud Prevention Card */}
            <div className="bg-white rounded-4 p-4 shadow-lg border position-relative" style={{ zIndex: 5, borderColor: '#a7f3d0' }}>
              <h3 className="h4 font-weight-bold mb-4" style={{ color: '#012b2a' }}>Fraud Prevention</h3>
              
              <ul className="list-unstyled mb-0 d-flex flex-column gap-3">
                <li className="d-flex align-items-center gap-3">
                  <span className="rounded-circle d-inline-flex align-items-center justify-content-center text-white flex-shrink-0" style={{ width: '26px', height: '26px', backgroundColor: '#012b2a' }}>
                    <i className="fa-solid fa-check text-lime" style={{ fontSize: '12px' }}></i>
                  </span>
                  <span className="font-weight-bold" style={{ fontSize: '0.95rem', color: '#012b2a' }}>liveness checks</span>
                </li>
                <li className="d-flex align-items-center gap-3">
                  <span className="rounded-circle d-inline-flex align-items-center justify-content-center text-white flex-shrink-0" style={{ width: '26px', height: '26px', backgroundColor: '#012b2a' }}>
                    <i className="fa-solid fa-check text-lime" style={{ fontSize: '12px' }}></i>
                  </span>
                  <span className="font-weight-bold" style={{ fontSize: '0.95rem', color: '#012b2a' }}>document forgery detection</span>
                </li>
                <li className="d-flex align-items-center gap-3">
                  <span className="rounded-circle d-inline-flex align-items-center justify-content-center text-white flex-shrink-0" style={{ width: '26px', height: '26px', backgroundColor: '#012b2a' }}>
                    <i className="fa-solid fa-check text-lime" style={{ fontSize: '12px' }}></i>
                  </span>
                  <span className="font-weight-bold" style={{ fontSize: '0.95rem', color: '#012b2a' }}>risk scoring</span>
                </li>
              </ul>
            </div>

            {/* Bottom Left 3D Metallic Shield Illustration & Icons */}
            <div className="mt-4 pt-2 d-flex align-items-center justify-content-between position-relative" style={{ zIndex: 5 }}>
              
              {/* Shield Graphic Unit */}
              <div className="position-relative d-inline-flex align-items-center justify-content-center" style={{ width: '110px', height: '110px' }}>
                {/* Concentric rings */}
                <div className="position-absolute rounded-circle border border-2 opacity-50" style={{ width: '100px', height: '100px', borderColor: '#10b981' }}></div>
                <div className="position-absolute rounded-circle border border-2 opacity-75" style={{ width: '80px', height: '80px', borderColor: '#059669' }}></div>
                
                {/* 3D Shield Badge */}
                <div className="rounded-4 text-lime d-flex align-items-center justify-content-center shadow-lg position-relative" style={{ width: '64px', height: '64px', background: 'linear-gradient(135deg, #012b2a 0%, #043836 100%)', boxShadow: '0 12px 24px -6px rgba(1, 43, 42, 0.5)', border: '2px solid #ccff00' }}>
                  <i className="fa-solid fa-shield-check fa-2x"></i>
                  {/* Small floating badges */}
                  <span className="position-absolute bg-white rounded-circle shadow-sm d-flex align-items-center justify-content-center" style={{ width: '24px', height: '24px', top: '-6px', left: '-6px', color: '#012b2a', border: '1px solid #10b981', fontSize: '11px' }}>
                    <i className="fa-solid fa-user"></i>
                  </span>
                  <span className="position-absolute bg-white rounded-circle shadow-sm d-flex align-items-center justify-content-center" style={{ width: '24px', height: '24px', bottom: '-6px', right: '-6px', color: '#012b2a', border: '1px solid #10b981', fontSize: '11px' }}>
                    <i className="fa-solid fa-file-lines"></i>
                  </span>
                </div>
              </div>

              {/* Decorative Emerald Arrow & Sparkle Star */}
              <div className="position-relative d-flex flex-column align-items-end pe-2">
                <i className="fa-solid fa-sparkles mb-1" style={{ color: '#059669', fontSize: '20px' }}></i>
                <svg width="90" height="45" viewBox="0 0 90 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 38C25 42 60 40 80 10" stroke="#059669" strokeWidth="3" strokeLinecap="round" strokeDasharray="4 2"/>
                  <path d="M72 7L83 8L81 19" stroke="#059669" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>

            </div>

          </div>
        </div>

        {/* RIGHT CARD: Security & Compliance Architecture Flow Card (Styled in Mokshiq Dark Emerald & Lime Green Theme) */}
        <div className="col-lg-6 col-xl-6">
          <div className="card h-100 border-0 rounded-4 shadow-lg overflow-hidden p-4 p-md-5" style={{ backgroundColor: '#f0fdf4', border: '2px solid #10b981' }}>
            
            {/* Top Brand Header Box */}
            <div className="text-center mb-4">
              <div className="bg-dark-emerald d-inline-flex align-items-center justify-content-center px-4 py-2 rounded-4 shadow-sm border" style={{ backgroundColor: '#012b2a', borderColor: '#ccff00' }}>
                <span className="font-weight-bold fs-5 text-white">
                  <span style={{ color: '#ccff00' }}>Verify</span>
                </span>
                <span className="text-white-50 ms-2 small" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>By Mokshiq</span>
              </div>

              {/* Tree Connection Line */}
              <div className="mx-auto" style={{ width: '2px', height: '20px', borderLeft: '2px dashed #10b981' }}></div>
              <div className="mx-auto" style={{ width: '70%', height: '2px', borderTop: '2px dashed #10b981' }}></div>
            </div>

            {/* 4 Modular Flow Cards Grid */}
            <div className="row g-3">
              
              {/* Card 1: Auditability */}
              <div className="col-sm-6">
                <div className="bg-white p-3 rounded-4 border shadow-sm h-100 d-flex flex-column justify-content-between" style={{ borderColor: '#a7f3d0' }}>
                  <div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="rounded-3 p-2 d-inline-flex align-items-center justify-content-center" style={{ backgroundColor: '#d1fae5', color: '#012b2a', width: '38px', height: '38px' }}>
                        <i className="fa-solid fa-sitemap"></i>
                      </div>
                      
                      {/* Interactive Toggle */}
                      <div className="form-check form-switch m-0 p-0 d-flex align-items-center">
                        <input 
                          className="form-check-input cursor-pointer" 
                          type="checkbox" 
                          role="switch"
                          checked={toggles.auditability} 
                          onChange={() => toggleHandler('auditability')}
                          style={{ width: '42px', height: '22px', cursor: 'pointer', backgroundColor: toggles.auditability ? '#059669' : '#cbd5e1' }}
                        />
                      </div>
                    </div>
                    <h4 className="h6 font-weight-bold mb-2" style={{ color: '#012b2a' }}>Auditability</h4>
                    <ul className="list-unstyled small text-muted mb-0 d-flex flex-column gap-1">
                      <li className="d-flex align-items-center gap-2" style={{ fontSize: '12px', color: '#012b2a' }}>
                        <i className="fa-solid fa-circle-check" style={{ fontSize: '10px', color: '#059669' }}></i>
                        <span className="fw-medium">Complete activity logs</span>
                      </li>
                      <li className="d-flex align-items-center gap-2" style={{ fontSize: '12px', color: '#012b2a' }}>
                        <i className="fa-solid fa-circle-check" style={{ fontSize: '10px', color: '#059669' }}></i>
                        <span className="fw-medium">End-to-end traceability</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Card 2: Consent Management */}
              <div className="col-sm-6">
                <div className="bg-white p-3 rounded-4 border shadow-sm h-100 d-flex flex-column justify-content-between" style={{ borderColor: '#a7f3d0' }}>
                  <div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="rounded-3 p-2 d-inline-flex align-items-center justify-content-center" style={{ backgroundColor: '#d1fae5', color: '#012b2a', width: '38px', height: '38px' }}>
                        <i className="fa-solid fa-shield-halved"></i>
                      </div>
                      
                      {/* Interactive Toggle */}
                      <div className="form-check form-switch m-0 p-0 d-flex align-items-center">
                        <input 
                          className="form-check-input cursor-pointer" 
                          type="checkbox" 
                          role="switch"
                          checked={toggles.consent} 
                          onChange={() => toggleHandler('consent')}
                          style={{ width: '42px', height: '22px', cursor: 'pointer', backgroundColor: toggles.consent ? '#059669' : '#cbd5e1' }}
                        />
                      </div>
                    </div>
                    <h4 className="h6 font-weight-bold mb-2" style={{ color: '#012b2a' }}>Consent Management</h4>
                    <ul className="list-unstyled small text-muted mb-0 d-flex flex-column gap-1">
                      <li className="d-flex align-items-center gap-2" style={{ fontSize: '12px', color: '#012b2a' }}>
                        <i className="fa-solid fa-circle-check" style={{ fontSize: '10px', color: '#059669' }}></i>
                        <span className="fw-medium">Granular user consent</span>
                      </li>
                      <li className="d-flex align-items-center gap-2" style={{ fontSize: '12px', color: '#012b2a' }}>
                        <i className="fa-solid fa-circle-check" style={{ fontSize: '10px', color: '#059669' }}></i>
                        <span className="fw-medium">Consent version control</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Card 3: Data Residency */}
              <div className="col-sm-6">
                <div className="bg-white p-3 rounded-4 border shadow-sm h-100 d-flex flex-column justify-content-between" style={{ borderColor: '#a7f3d0' }}>
                  <div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="rounded-3 p-2 d-inline-flex align-items-center justify-content-center" style={{ backgroundColor: '#d1fae5', color: '#012b2a', width: '38px', height: '38px' }}>
                        <i className="fa-solid fa-file-shield"></i>
                      </div>
                      
                      {/* Interactive Toggle */}
                      <div className="form-check form-switch m-0 p-0 d-flex align-items-center">
                        <input 
                          className="form-check-input cursor-pointer" 
                          type="checkbox" 
                          role="switch"
                          checked={toggles.residency} 
                          onChange={() => toggleHandler('residency')}
                          style={{ width: '42px', height: '22px', cursor: 'pointer', backgroundColor: toggles.residency ? '#059669' : '#cbd5e1' }}
                        />
                      </div>
                    </div>
                    <h4 className="h6 font-weight-bold mb-2" style={{ color: '#012b2a' }}>Data Residency</h4>
                    <ul className="list-unstyled small text-muted mb-0 d-flex flex-column gap-1">
                      <li className="d-flex align-items-center gap-2" style={{ fontSize: '12px', color: '#012b2a' }}>
                        <i className="fa-solid fa-circle-check" style={{ fontSize: '10px', color: '#059669' }}></i>
                        <span className="fw-medium">Region-specific storage</span>
                      </li>
                      <li className="d-flex align-items-center gap-2" style={{ fontSize: '12px', color: '#012b2a' }}>
                        <i className="fa-solid fa-circle-check" style={{ fontSize: '10px', color: '#059669' }}></i>
                        <span className="fw-medium">Local data processing</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Card 4: Regulatory Alignment */}
              <div className="col-sm-6">
                <div className="bg-white p-3 rounded-4 border shadow-sm h-100 d-flex flex-column justify-content-between" style={{ borderColor: '#a7f3d0' }}>
                  <div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="rounded-3 p-2 d-inline-flex align-items-center justify-content-center" style={{ backgroundColor: '#d1fae5', color: '#012b2a', width: '38px', height: '38px' }}>
                        <i className="fa-solid fa-user-lock"></i>
                      </div>
                      
                      {/* Interactive Toggle */}
                      <div className="form-check form-switch m-0 p-0 d-flex align-items-center">
                        <input 
                          className="form-check-input cursor-pointer" 
                          type="checkbox" 
                          role="switch"
                          checked={toggles.regulatory} 
                          onChange={() => toggleHandler('regulatory')}
                          style={{ width: '42px', height: '22px', cursor: 'pointer', backgroundColor: toggles.regulatory ? '#059669' : '#cbd5e1' }}
                        />
                      </div>
                    </div>
                    <h4 className="h6 font-weight-bold mb-2" style={{ color: '#012b2a' }}>Regulatory Alignment</h4>
                    <ul className="list-unstyled small text-muted mb-0 d-flex flex-column gap-1">
                      <li className="d-flex align-items-center gap-2" style={{ fontSize: '12px', color: '#012b2a' }}>
                        <i className="fa-solid fa-circle-check" style={{ fontSize: '10px', color: '#059669' }}></i>
                        <span className="fw-medium">KYC / AML compliant</span>
                      </li>
                      <li className="d-flex align-items-center gap-2" style={{ fontSize: '12px', color: '#012b2a' }}>
                        <i className="fa-solid fa-circle-check" style={{ fontSize: '10px', color: '#059669' }}></i>
                        <span className="fw-medium">Policy &amp; standards ready</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>

            {/* Bottom Shield Center Node */}
            <div className="text-center mt-4">
              <div className="mx-auto" style={{ width: '60px', height: '20px', borderTop: '2px dashed #10b981', borderRadius: '50% 50% 0 0' }}></div>
              <div className="bg-dark-emerald d-inline-flex align-items-center justify-content-center p-2 rounded-circle shadow-sm border" style={{ backgroundColor: '#012b2a', borderColor: '#ccff00', width: '42px', height: '42px' }}>
                <i className="fa-solid fa-shield-check text-lime"></i>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}

export default HomepageVisualCards;
